import React from "react";
import AnimatedContent from "../common/AnimatedContent";
import PageTitle from "../common/PageTitle";
import UserTable from "../Components/user/UserTable";
import { RoleList } from "../Enum/RoleList";
import { Button } from "@windmill/react-ui";
import UserForm from "../Components/user/UserForm";
import Drawer from "../common/Drawer";

import useUser from "../hooks/useUser";
import CustomSearch from "../common/CustomSearch";
import { BiEdit } from "react-icons/bi";
import { FaRegCalendarCheck } from "react-icons/fa6";
import Model from "../common/Model";
import Loading from "../common/Loading";

const User = () => {
  const {
    user,
    loading,
    register,
    handleSubmit,
    errors,
    watch,
    visible,
    setVisible,
    handleUserManage,
    exiting,
    setExiting,
    handleExitingData,

    handleToggle,
    handleSearchSubmit,
    setSearchKey,

    limit,

    currentPage,

    nextId,
    prevId,
    handlePageChange,
    handlePageSize,
    handleStatus,
    openStatus,
    setOpenStatus,
    handleDeactiveUser,
    userResignCount,
    loading2,
    hasMore
  } = useUser();

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text) => (
        <div title={text} className=" text-center truncate">
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text) => (
        <div className="mx-auto flex items-center justify-center gap-2 w-max text-center">
          <div>{text}</div>
        </div>
      ),
    },
    {
      key: "createdDate",
      title: "Created Date",
      render: (text) => (
        <div className="bg-green-50 mx-auto flex items-center justify-center gap-2 text-xs border border-green-500 rounded-full p-1 w-max text-center">
          <FaRegCalendarCheck className="text-primary" />
            <div>{text.replace(/\//g, "-")}</div>
        </div>
      ),
    },
    {
      key: "role",
      title: "Role",
      render: (text) => {
        const matchRole = RoleList.find((role) => role.value === text);
      
        
      
        if (!matchRole) return null;
        return (
          <div className="bg-violet-50 w-[150px] mx-auto flex items-center justify- gap-2 text-xs border border-violet-500 rounded-full p-1 text-center">
            <img src={matchRole?.icon} alt="" className="w-5" />
            <div className="text-nowrap">{matchRole?.label}</div>
          </div>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      render: (text) => (
        <div
          className={`text-xs px-3 py-1 rounded-full w-max mx-auto font-semibold ${
            text
              ? "bg-green-50 text-green-700 border border-green-400"
              : "bg-red-50 text-red-700 border border-red-400"
          }`}
        >
          {text ? "Active" : "Inactive"}
        </div>
      ),
    },
    {
      key: "Action",
      title: "Action",
      render: (text, record) => (
        <div className="flex justify-center cursor-pointer items-center gap-4 text-blue-500 text-lg font-semibold">
          <BiEdit onClick={() => handleExitingData(record)} />
        </div>
      ),
    },
  ];

  const handleSearchChange = (e) => {
    setSearchKey(e.target.value);
  };
  const handleClose = () => {
    setOpenStatus(false);
  };

  return (
    <div>
       {loading2 &&(
          <Loading/>
        )}
      <AnimatedContent>
       
        <div className="flex items-center justify-between mb-5">
       
          <PageTitle title="Users" />
          <div className="flex items-center gap-3">
            <CustomSearch
              handleSearchChange={handleSearchChange}
              handleSearchSubmit={handleSearchSubmit}
              placeholder="Search by name"
            />
            <Button
              className="bg-primary rounded-[10px] w-[131px] h-[50px] text-white px-3"
              onClick={handleToggle}
            >
              Add User
            </Button>
          </div>
        </div>
        <UserTable
          columns={columns}
          loading={loading}
          data={user}
          limit={limit}
          currentPage={currentPage}
          nextId={nextId}
          prevId={prevId}
          handlePageChange={handlePageChange}
          handlePageSize={handlePageSize}
          hasMore={hasMore}
        />
      </AnimatedContent>
      <Drawer open={visible} onClose={() => {
        setVisible(false);
        setExiting(false)

      }} title="Add New User">
        <UserForm
          register={register}
          loading={loading}
          exiting={exiting}
          errors={errors}
          watch={watch}
          handleSubmit={handleSubmit}
          onSubmit={handleUserManage}
          handleStatus={handleStatus}
        />
      </Drawer>
      <Model
        show={openStatus}
        userResignCount={userResignCount}
        close={()=>{
          setVisible(false);
          setOpenStatus(false);
        }}
        title={"Are you sure you want to deactivate this user?"}
        message={
          userResignCount > 0
            ? `Resign personal ${userResignCount} first, then deactivate the user.`
            : "Are you sure you want to deactivate this user?"
        }
        userDeactiveHandle={
          userResignCount > 0 ? handleClose : handleDeactiveUser
        }
      />
    </div>
  );
};

export default User;
